<ng-template #content let-modal>
  <app-element-loader
    [loadingMessage]="loadingMessage"
    [loadingStatus]="loadingStatus"
  ></app-element-loader>
  <div class="modal-header modal-custom__header modal__destinations-header">
    <div class="d-flex destination-wrapper">
      <h4 class="modal-title" id="modal-basic-title"><i class="icon-pin"></i> Dove vuoi andare?</h4>
      <div class="modal-footer modal-custom__footer modal__destinations-footer destinations-thumbnail__bottom">
        <div class="destinations-thumbnail__search">
          <div class="form-group-custom">
            <div class="input-group-custom input-group-custom--icon-append input-group-custom--icon-append--transparent">
              <input type="text" class="form-control-custom" id="inputSearchDestination"
                     placeholder="Inserisci almeno 3 caratteri..."
                     name="freeSearch"
                     [(ngModel)]="selectedDestinationInner"
                     [resultFormatter]="destinationFormatter"
                     [inputFormatter]="destinationFormatter"
                     [editable]='false'
                     (selectItem)="destinationChangeCB($event)"
                     [ngbTypeahead]="destinationSearch">
              <span [hidden]="!typeaheadLoading" class="spinner-border"></span>
              <div class="input-group-custom__append input-group-custom__append--transparent" *ngIf="selectedDestinationInner" (click)="destinationClearCB()">
                <span class="input-group-custom__icon input-group-custom__icon--transparent"><i class="g-icon-close"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button #close type="button" class="close modal-close" aria-label="close" (click)="modal.dismiss()">
      <span aria-hidden="true">Chiudi <i class="icon-close"></i></span>
    </button>
  </div>
  <div class="modal-body modal-custom__body modal__destinations-body">
    <div class="destinations-thumbnail" *ngIf="!(isMobile$ | async)">
      <app-holiday-destinations-slider
        (selectedDestination)="onSelectedDestination($event)"
        [destinationBox$]="destinationBox$"
      ></app-holiday-destinations-slider>
    </div>
    <div class="destinations-thumbnail" *ngIf="(isMobile$ | async)">
      <app-holiday-destinations-list
        (selectedDestination)="onSelectedDestination($event)"
        [destinationBox$]="destinationBox$"
      ></app-holiday-destinations-list>
    </div>
  </div>
  <!--<div class="modal-footer modal-custom__footer modal__destinations-footer destinations-thumbnail__bottom">
    <div class="destinations-thumbnail__search">
      <div class="form-group-custom">
        <label for="inputSearchDestination" class="input-group-custom__label">Cerca la destinazione</label>
        <div class="input-group-custom input-group-custom&#45;&#45;icon-append input-group-custom&#45;&#45;icon-append&#45;&#45;transparent">
          <input type="text" class="form-control-custom" id="inputSearchDestination"
                 placeholder="Inserisci almeno 3 caratteri..."
                 name="freeSearch"
                 [(ngModel)]="selectedDestinationInner"
                 [resultFormatter]="destinationFormatter"
                 [inputFormatter]="destinationFormatter"
                 [editable]='false'
                 (selectItem)="destinationChangeCB($event)"
                 [ngbTypeahead]="destinationSearch">
          <span [hidden]="!typeaheadLoading" class="spinner-border"></span>
          <div class="input-group-custom__append input-group-custom__append&#45;&#45;transparent" *ngIf="selectedDestinationInner" (click)="destinationClearCB()">
            <span class="input-group-custom__icon input-group-custom__icon&#45;&#45;transparent"><i class="g-icon-close"></i></span>
          </div>
      </div>
    </div>
    </div>
  </div>-->
</ng-template>

<div class="form-group-custom">
  <label for="inputDestinationTour" class="input-group-zeus__label">Destinazione</label>
  <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="holidayDestination-dropdown">
    <input type="text" class="form-control-custom" id="inputDestinationTour" [placeholder]="selectedDestinationInner? selectedDestinationInner.name : 'Seleziona la destinazione...'"
           aria-label="Destinazione"
           aria-describedby="basic-addon3"
           (click)="open(content)" readonly>
    <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
      <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon3"><i class="icon-pin"></i></span>
    </div>
  </div>
</div>
